<div class="typing-wrapper">
  <div class="avatar">
    <span>🤖</span>
  </div>
  <div class="typing-bubble">
    <div class="typing-dots">
      <div class="typing-dot"></div>
      <div class="typing-dot"></div>
      <div class="typing-dot"></div>
    </div>
    <span class="typing-label">{{ label }}</span>
  </div>
</div>
